import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { animateScroll as scroll } from 'react-scroll';
import Text from '../Typography/Text';
import Social from '../Social';
import getEntityField from '~/src/lib/getEntityField';
import { useScreenDetector } from '~/src/hooks/useScreenDetector';
import Link from 'next/link';
import brightnessColor from '~/src/lib/common/utils/brightnessColor';
import getCustomBg3 from '~/src/lib/getCustomBg3';
import config from '~/src/config';
import useOnScreen from '~/src/hooks/useOnScreen';
import isIos from '~/src/lib/isIos';
import translateMsg from '~/src/lib/translateMsg';
import Image from 'next/image';
import Head from 'next/head';

const styles = {
    top: {
        display: 'flex',

        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        // height: 40,
        padding: 10,
    },
    bottom: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: 10,
    },
    bottom1: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: 10,
    },
    rgpd: {
        //backgroundColor: '#242b35',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        // paddingLeft: 15,
        // paddingRight: 15,
        // height: 30
        padding: 10,
    },
};

function Footer(props) {
    const lang = useSelector((state) => state.lang);
    const business = useSelector((state) => state.business);
    const { isMobile, isTablet, isDesktop } = useScreenDetector();
    const dispatch = useDispatch();

    const ref = useRef();
    const onScreen = useOnScreen(ref, '-0px');

    if (typeof business === 'undefined') {
        return false;
    }

    if (Object.keys(business).length === 0) {
        return false;
    }

    if (
        typeof document !== 'undefined' &&
        document.location &&
        document.location.pathname === '/presentation'
    ) {
        //return false;
    }

    const bg = getCustomBg3(business);
    const brightnessByColor = brightnessColor(bg);
    const color = brightnessByColor < 122 ? '#FFFFFF' : '#000000';

    let logo_url = config.logoUrl;

    if (brightnessByColor > 122) {
        if (typeof business?.info?.whitelabel?.dark_logo === 'string') {
            logo_url = business.info.whitelabel.dark_logo;
        }
    } else {
        if (typeof business?.info?.whitelabel?.bright_logo === 'string') {
            logo_url = business.info.whitelabel.bright_logo;
        }
    }

    let url = '/';
    if (
        typeof business?.info?.whitelabel?.url === 'string' &&
        business?.info?.whitelabel?.url.length > 0
    ) {
        url = business.info.whitelabel.url;
    }

    const sidebar = document.getElementById('sidebar');
    const sidebarBottom = document.getElementById('sidebar-bottom');

    if (sidebar && sidebarBottom) {
        if (onScreen === false) {
            //sidebar.style.position = "sticky";
            sidebarBottom.style.position = 'fixed';
        } else {
            //sidebar.style.position = "relative";
            sidebarBottom.style.position = 'relative';
        }
    }

    const _getBottom = () => {
        let nb = 0;
        if (getEntityField(business.info, 'cgv').length > 2) {
            nb++;
        }

        if (getEntityField(business.info, 'legal_mention').length > 2) {
            nb++;
        }

        if (nb === 0) {
            return false;
        }

        if (nb === 1) {
            return (
                <div style={styles.bottom1}>
                    {getEntityField(business.info, 'cgv').length > 10 ? (
                        <div>
                            <Link
                                href="/cgv"
                                locale={lang}
                                style={{ textDecoration: 'none', color: color }}
                            >
                                <Text variant="body1">
                                    {translateMsg('webapp', 'pwa_ui_t_and_c')}
                                </Text>
                            </Link>
                        </div>
                    ) : (
                        false
                    )}

                    {getEntityField(business.info, 'legal_mention').length >
                    10 ? (
                        <div>
                            <Link
                                href="/legal_mention"
                                locale={lang}
                                style={{ textDecoration: 'none', color: color }}
                            >
                                <Text variant="body1">
                                    {translateMsg(
                                        'webapp',
                                        'pwa_ui__legal_notice',
                                    )}
                                </Text>
                            </Link>
                        </div>
                    ) : (
                        false
                    )}
                </div>
            );
        }

        if (nb === 2) {
            return (
                <div style={styles.bottom}>
                    <div>
                        <Link
                            href="/cgv"
                            locale={lang}
                            style={{ textDecoration: 'none', color: color }}
                        >
                            <Text variant="body1">
                                {translateMsg('webapp', 'pwa_ui_t_and_c')}
                            </Text>
                        </Link>
                    </div>

                    <div>
                        <Link
                            href="/legal_mention"
                            locale={lang}
                            style={{ textDecoration: 'none', color: color }}
                        >
                            <Text variant="body1">
                                {translateMsg('webapp', 'pwa_ui__legal_notice')}
                            </Text>
                        </Link>
                    </div>
                </div>
            );
        }

        return false;
    };

    const _displayNoIndex = () => {
        //https://trello.com/c/OSNTymSe/3889-gestion-de-lindexation-google-dans-les-websites

        //console.log('_displayNoIndex');
        //console.log(business.info.webapp_url);
        //console.log(document.location.host);

        if (
            typeof business.info.webapp_url === 'string' &&
            business.info.webapp_url.length > 2
        ) {
            const ar = ['localhost', 'bienchoisir', 'menuchic', 'foound'];
            let result = false;
            ar.map((a) => {
                if (document.location.host.indexOf(a) !== -1) {
                    //console.log(22222);
                    result = true;
                }
            });

            if (result === false) {
                return false;
            }
        }

        //console.log(11111);
        //console.log(config.isIndexUrl);

        if (config.isIndexUrl === true) {
            return false;
        }

        //console.log(22222);
        //console.log(+business.info.status_id);

        if (+business.info.status_id === 1) {
            return false;
        }

        //console.log(33333);

        return <meta key="robots" name="robots" content="noindex, nofollow" />;
    };

    //console.log('footer');
    //console.log(business.info);
    //console.log(config.isIndexUrl);
    //console.log(+business.info.status_id);

    config.isIndexUrl === false || +business.info.status_id !== 1;

    return (
        <>
            <div ref={ref} style={{}}></div>
            <div
                id="footer"
                style={{
                    backgroundColor: business.info.custom_bg3
                        ? business.info.custom_bg3
                        : '#000000',
                    color: '#ffffff',
                    //minHeight: 250,
                    //marginTop: 200
                    paddingBottom: 60,
                }}
            >
                <div style={styles.top}>
                    {typeof business.social === 'object' &&
                    !isMobile &&
                    business.social.length > 0 ? (
                        <React.Fragment>
                            <div
                                style={{
                                    //width: 200,
                                    textAlign: 'left',
                                    //border: '1px solid red',
                                    flex: 1,
                                }}
                            >
                                <Link href={url} locale={lang}>
                                    <img
                                        alt="logo"
                                        height="30"
                                        width="auto"
                                        src={logo_url}
                                    />
                                </Link>
                            </div>
                            <div
                                style={
                                    {
                                        //border: '1px solid blue',
                                    }
                                }
                            >
                                <Social
                                    color={
                                        business.info.custom_bg3
                                            ? business.info.custom_bg3
                                            : '#000000'
                                    }
                                    business={business}
                                />
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div style={{ textAlign: 'center', width: '100%' }}>
                                <Link href={url} locale={lang}>
                                    <img
                                        style={{ marginLeft: 40 }}
                                        alt="logo"
                                        height="30"
                                        src={logo_url}
                                    />
                                </Link>
                            </div>
                        </React.Fragment>
                    )}

                    <div
                        style={{
                            cursor: 'pointer',
                            //width: 200,
                            textAlign: 'right',
                            flex: 1,
                            //border: '1px solid red'
                        }}
                    >
                        <KeyboardArrowUpIcon
                            style={{
                                fontSize: 40,
                                color: color,
                            }}
                            onClick={(event) => {
                                event.preventDefault();
                                scroll.scrollToTop({
                                    duration: 500,
                                    delay: 100,
                                    smooth: true,
                                });
                            }}
                        />
                    </div>
                </div>
                {typeof business.social === 'object' &&
                    isMobile &&
                    business.social.length > 0 && (
                        <div
                            style={{
                                textAlign: 'center',
                                justifyContent: 'center',
                                justifyItems: 'center',
                                paddingLeft: 20,
                                paddingRight: 20,
                            }}
                        >
                            <Social
                                color={
                                    business.info.custom_bg3
                                        ? business.info.custom_bg3
                                        : '#000000'
                                }
                                business={business}
                            />
                        </div>
                    )}

                {_getBottom()}
            </div>

            <Head>{_displayNoIndex()}</Head>
        </>
    );
}

export default Footer;
